import { AppointmentManagement } from "@/components/AppointmentManagement";

export default function AppointmentsPage() {
  return <AppointmentManagement />;
}


